<template>
  <div class="services-header">
    <div class="tariff-section">
      <i v-if="$props.headerInfo.subscriptionType === 'FIXED_TELEPHONY'" class="icon icon-sc-landline"></i>
      <i v-else-if="$props.headerInfo.subscriptionType === 'INTERNET'" class="icon icon-sc-internet"></i>
      <i v-else-if="$props.headerInfo.subscriptionType === 'TELEVISION'" class="icon icon-sc-tv"></i>
      <i v-else-if="$props.headerInfo.subscriptionType === 'MOBILE_PREPAID' ||
               $props.headerInfo.subscriptionType === 'MOBILE_POSTPAID'" class="icon icon-sc-mobile"></i>
      <div>
        <h5 class="identity">{{ $props.headerInfo.headerTitle }}</h5>
        <p class="sub">{{ $props.headerInfo.headerDescription }}</p>
      </div>
    </div>
    <div class="account-section">
      <p class="account-info"
         v-if="headerSubscriptionType">
        {{ $t('headerInfo.accountBalance') }}: <span class="value">{{ $props.balance ? $props.balance.formattedValue : '' }}</span>
      </p>
      <p class="account-info"
         v-if="$props.headerInfo.subscriptionType === 'MOBILE_PREPAID'">
        {{ $t('headerInfo.accountPrepaidBalance') }}: <span class="value">{{ $props.balance ? $props.balance.formattedValue : '' }}</span>
      </p>
      <p class="account-info" v-if="$props.headerInfo.subscriptionType === 'MOBILE_PREPAID'">
        {{ $t('headerInfo.cardExpiryDate') }}: <span>{{ $props.headerInfo.balance.formattedExpiredDate   || '-' }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-services-overview',
  props: {
    headerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    balance: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    headerSubscriptionType () {
      return ['MOBILE_POSTPAID', 'FIXED_TELEPHONY', 'INTERNET', 'TELEVISION'].includes(this.$props.headerInfo.subscriptionType)
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/styles/components/_services-header.scss"></style>
